import { useDraggable } from '@dnd-kit/core';
import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import type { FC, Key } from 'react';

interface Props {
  title: React.ReactNode;
  keyNode: Key;
  count: number;
}

export const CustomDataNodeDraggable: FC<Props> = ({ title, keyNode, count }: Props) => {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `filter-tree:${String(keyNode)}`,
    data: { type: 'filter-tree', key: String(keyNode), count },
  });

  return (
    <Container
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      isDragging={isDragging}
      canDrag={true}
      isInteractable={true}
    >
      <Title>{title}</Title>
      <CountField>{count}</CountField>
    </Container>
  );
};

const Container = styled.div<{ canDrag?: boolean; isDragging?: boolean; isInteractable: boolean }>`
    display: flex;
    justify-content: space-between;
    min-width: 0;
    ${({ isDragging }) => (isDragging ? `color: ${RacemapColors.PaleBlue};` : '')}

    ${({ canDrag, isInteractable }) =>
      canDrag ? 'cursor: grab;' : isInteractable ? 'cursor: pointer;' : ''}
  `;

const CountField = styled.div`
    color: ${RacemapColors.DarkGray};
    margin-left: 4px;
  `;

const Title = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;
